export enum Action {
  Changed = 'CHANGED',
  Toileted = 'TOILETED',
  Checked = 'CHECKED',
}

export enum Reason {
  Wet = 'WET',
  Dry = 'DRY',
  BM = 'BM',
  NoChange = 'NO_CHANGE',
  Change = 'CHANGE',
}

export enum EventType {
  Wet = 'WET',
  Dry = 'DRY',
  BM = 'BM',
}

export const ACTIONS: { label: string; value: Action }[] = [
  { label: 'Changed', value: Action.Changed },
  { label: 'Toileted', value: Action.Toileted },
  { label: 'Checked', value: Action.Checked },
];
export const EVENT_TYPES: { label: string; value: EventType }[] = [
  { label: 'Wet', value: EventType.Wet },
  { label: 'Dry', value: EventType.Dry },
  { label: 'BM', value: EventType.BM },
];

export const REASONS_MAP: {
  [key in Action]: { label: string; value: Reason }[];
} = {
  [Action.Changed]: [
    { label: 'Wet', value: Reason.Wet },
    { label: 'Dry', value: Reason.Dry },
    { label: 'BM', value: Reason.BM },
  ],
  [Action.Toileted]: [
    { label: 'No Change', value: Reason.NoChange },
    { label: 'Change', value: Reason.Change },
  ],
  [Action.Checked]: [
    { label: 'Wet', value: Reason.Wet },
    { label: 'Dry', value: Reason.Dry },
    { label: 'BM', value: Reason.BM },
  ],
};

export interface CareEventPayload {
  action: Action;
  reason: Reason;
  eventType?: EventType;
  performedBy: string;
  notes: string;
}
